// extracted by mini-css-extract-plugin
export default {"dialogCloseButton":"PodcastHighlightClipScroller_dialogCloseButton__vT2EX","swiper":"PodcastHighlightClipScroller_swiper__nwsdh","fade":"PodcastHighlightClipScroller_fade__iNLJs"};